<div class="dashboard-container">
  <main class="dashboard-main">
    <div class="dashboard-content">
      <div class="welcome-card">
        <div class="welcome-icon">
          <mat-icon>dashboard</mat-icon>
        </div>
        <h2>Welcome to AI Optima</h2>
        <p>Your comprehensive platform for brand analysis, competitive intelligence, and AI-powered market insights.
        </p>
      </div>

      <div class="features-grid">
        <!-- (click)="navigateToBrandAnalysis('brand-analysis')" -->
        <div class="feature-card">
          <div class="feature-icon">
            <mat-icon>analytics</mat-icon>
          </div>
          <h3>Brand Analysis</h3>
          <p>Comprehensive brand analysis with AI-powered insights, competitive benchmarking, and market intelligence.</p>
        </div>

        <!-- (click)="navigateToBrandAnalysis('competitive-intelligence')" -->
        <div class="feature-card">
          <div class="feature-icon">
            <mat-icon>trending_up</mat-icon>
          </div>
          <h3>Competitive Intelligence</h3>
          <p>Monitor competitor performance, track market trends, and identify strategic opportunities.</p>
        </div>
      </div>

      <div class="quick-stats">
        <h3>Quick Overview</h3>
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-number">{{ analysesCompleted }}</div>
            <div class="stat-label">Analyses Completed</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">{{ reportsGenerated }}</div>
            <div class="stat-label">Reports Generated</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">{{ insightsDiscovered }}</div>
            <div class="stat-label">Insights Discovered</div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
